document.addEventListener("DOMContentLoaded", function () {
    const formContainer = document.querySelector("form#gform_2");

    if (!formContainer) {
        return;
    }

    // Function to handle checkbox selection based on ranges
    function selectCheckboxesByRanges(ranges) {
        if (!ranges) return;
        
        const checkboxes = formContainer.querySelectorAll("input[type='checkbox']");
        if (checkboxes.length === 0) return;

        // Convert the comma-separated string into an array of slugs
        const slugArray = ranges.split(",").map(slug => slug.trim());

        // Loop through all checkboxes and check those matching the slugs
        checkboxes.forEach(checkbox => {
            const checkboxSlugWithType = checkbox.value;
            const checkboxSlug = checkboxSlugWithType.split(":")[0].trim();

            checkbox.checked = slugArray.includes(checkboxSlug);
        });
    }

    // Check for URL parameter on page load
    function handleURLParameters() {
        const urlParams = new URLSearchParams(window.location.search);
        const rangesParam = urlParams.get('ranges');
        
        if (rangesParam) {

            console.log(rangesParam);

            selectCheckboxesByRanges(rangesParam);
        }
    }

    // Call the function to handle URL parameters on page load
    handleURLParameters();

    // Event listener for button clicks (existing functionality)
    document.addEventListener("click", function (event) {
        if (event.target.matches(".suggested-ranges button")) {
            const sectorName = event.target.innerText;
            const textarea = formContainer.querySelector("#input_2_1");

            if (textarea) {
                textarea.value = `Interested in: ${sectorName} sector`;
            }

            const ranges = event.target.dataset.ranges;

            console.log(ranges);
            selectCheckboxesByRanges(ranges);
        }
    });
});